import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import { CloudUploadAnimation } from '../loaders/upload-arrows/CloudUploadAnimation';
import styles from './UploadProgress.module.scss';

export const UploadProgress = ({ amountOfUploadsRemaining }: Props) => {

    const { t } = useTranslation();

    const containerClassName = classNames(styles.container, {
        [styles.completed]: amountOfUploadsRemaining === 0,
        [styles.notCompleted]: amountOfUploadsRemaining > 0
    });

    return (
        <div className={containerClassName}>
            <div className={styles.card}>
                {amountOfUploadsRemaining === 0 ? (
                    <div className={styles.text}>
                        <Icon type='alert-circle-check' className={classNames(styles.checkmark, styles.icon)} />
                        {t('upload_progress.complete')}
                    </div>
                ) : (
                    <div className={styles.text}>
                        <CloudUploadAnimation className={styles.icon} />
                        {t('upload_progress.amount_of_uploads_remaining', { count: amountOfUploadsRemaining })}
                    </div>
                )}

                <div className={styles.progressBar}>
                    <div className={styles.progress} />
                </div>
            </div>
        </div>
    );
};

type Props = {
    amountOfUploadsRemaining: number;
};